import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RoutingState } from 'src/app/models/state/routing-state.model';

export const selectRoutingState =
	createFeatureSelector<RoutingState>('routing');

export const selectCurrentRoute = createSelector(
	selectRoutingState,
	routingState => routingState.currentRoute
);

export const selectInitialRoute = createSelector(
	selectRoutingState,
	routingState => routingState.initialRoute
);

export const selectIsCurrentRouteSameAs = (nextRoute: string) =>
	createSelector(
		selectCurrentRoute,
		currentRoute => currentRoute === nextRoute
	);

export const selectIsCurrentRouteSameAsInitialRoute = createSelector(
	selectCurrentRoute,
	selectInitialRoute,
	(currentRoute, initialRoute) => currentRoute === initialRoute
);
